import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { TbCalendarFilled, } from 'react-icons/tb';
import GlobalTable from '../../components/global-table';
import { Button, Dialog, Flex, Typography } from '../../ppui';
import { logger } from '../../utils/logger';
import { ContentLayout, ContentTable } from '../style';
import { headers } from './payroll.data';
import Payrollservice from './payroll.service';
import SalaryBreakdown from './salary-details';


function Payroll() {
  const {
    open,
    handleClickOpen,
    handleClose,
    openEmployee,
    handleClickOpenEmployee,
    handleCloseEmployee,
    salarylistdata,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    setUserinfo,
    useInfo,
    serchinfo,
    setSearchinfo,
    UpdatePaySlip,
    ApprovedSalary,
    DeleteSalary,
    getList
  } = Payrollservice();

  const disableFutureMonths = (current) => {
    if (!current) return false; 
    const today = dayjs(); 
    const currentDate = dayjs(current);
    const endOfThisMonth = today.endOf('month');
    return currentDate.isAfter(endOfThisMonth);
  };

  const handleDateChange = (date) => {
    if (date) {
      const selectedYear = date.year(); 
      const selectedMonth = date.month() + 1;
      setSearchinfo({
        year: selectedYear,
        month: selectedMonth, 
      });
   
    }else {
      setSearchinfo({
        year: null,
        month: null,
      });
    }
  };

  logger.log(serchinfo,"searchQuery-payroll")



  return (
    <>
      <ContentLayout>
        <ContentTable>
          <GlobalTable
            headers={headers(currentPage, rowsPerPage)}
            rows={salarylistdata}
            ActiveSort={false}
            searchBox={true}
            columnManagement={true}
            avatar={true}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            totalPages={totalPages}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            FetchDataFromRow={(row) => handleClickOpenEmployee(row)}
            stickyHeader="true"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            // FetchApiforLIST={FetchApiforLIST}
            actionRight={
              <>
              <Button onClick={handleClickOpen} variant="outlined" icon={<TbCalendarFilled />}>
                  Select Month
                </Button>
              {( salarylistdata?.length>0 && serchinfo?.month && serchinfo?.year)&&
                <>
                  {salarylistdata.every(item => item.is_approve === false) ?
                    <Button color="primary" variant="contained" onClick={ApprovedSalary}>
                      Approve Payroll
                    </Button>
                    :
                    <Button color="primary" variant="contained" onClick={DeleteSalary}>
                      Delete Payroll
                    </Button>
                  }
                </>
              }
              </>
            }
            actionLeft={
              <>
            <Typography variant="h5" mb="0">
            
            {(serchinfo?.month && serchinfo?.year&& salarylistdata?.length>0) ? `Payroll of  ${dayjs().month(serchinfo.month - 1).format('MMMM,')} ${serchinfo?.year}` : "Payroll Management"}
            </Typography>
                
              </>
            }
          />
        </ContentTable>
      </ContentLayout>

      <Dialog
        title="Generate Payroll"
        closeButton={true}
        fullWidth
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        onSubmit={getList}
        bgClose
        separator
        actionAllign="right"
        buttonName={"Submit"}
        btnDisable={!serchinfo?.month || !serchinfo?.year}
      >
        <Flex direction="column" gap={20}>
          <DatePicker
            disabledDate={disableFutureMonths}
            format="YYYY-MM"
            value={( serchinfo?.year && serchinfo?.month) ? dayjs(new Date(serchinfo.year, serchinfo.month - 1)):null} 
            onChange={handleDateChange}
            picker="month" 
            allowClear
          />
        </Flex>
      </Dialog>

      <Dialog
        // title="Salary Details of February, 2028"
        title={`Salary Details  ${dayjs().month(serchinfo.month - 1).format('MMMM,')} ${serchinfo?.year}`}
        closeButton={true}
        fullWidth
        maxWidth="md"
        buttonName={"Submit"}
        open={openEmployee}
        onClose={handleCloseEmployee}
        onSubmit={() => UpdatePaySlip(useInfo)}
        action={true}
        separator
        bodyScroll
      >
        <SalaryBreakdown setUserinfo={setUserinfo} useInfo={useInfo} />
      </Dialog>
    </>
  );
}

export default Payroll;